import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import "moment/locale/es"; // Importa idioma español
import "moment/locale/en-gb"; // Importa idioma inglés (British English por ejemplo)
import "react-big-calendar/lib/css/react-big-calendar.css";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

import NavBreadcrum from "components/NavBreadcrum";
import CalendarTui from "./scheduler/CalendarTui";
import TabListRoutes from "./scheduler/TabListRoutes";
import {SwalAlertClass} from "core/swalClass";
import navs from "./navs";
import axiApi from "ApiCaller";

const ViewCalendar = () => {
    const {t} = useTranslation("routes");
    const {t: _Tf} = useTranslation("forms");
    const Alert = new SwalAlertClass({confirmButtonText: _Tf("labels.accept")});
    const title = t("labels.calendar");
    const bread = [
        {name: t("labels.route-management"), url: "/route-management", current: false},
        {name: t("labels.calendar"), current: true},
    ];
    const [keyTab, setKeyTab] = useState("scheduler");
    // null = programaciones aún no cargadas
    const [items, setItems] = useState(null);

    useEffect(() => {
        document.title = title;
        axiApi
            .get("/api/distribution/schedulers/")
            .then((resp) => {
                // console.log("ViewCalendar::useEffect -> resp.data:", resp.data);
                if (resp.data.status) {
                    setItems([...resp.data.items]);
                } else {
                    resp.data.message && console.error(resp.data.message);
                    Alert.error("Error en el servidor", "Consultar con el administrador.");
                    setItems([]);
                }
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
                setItems([]);
            });
    }, []);

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread} />
            <div className="row">
                <div className="col-md col-12 pt-3">
                    <Tabs activeKey={keyTab} id="scheduler-tabs" onSelect={(k) => setKeyTab(k)} className="mb-3 mt-1">
                        <Tab eventKey="scheduler" title={t("labels.calendar")}>
                            <CalendarTui items={items} />
                        </Tab>
                        <Tab eventKey="routes" title={t("labels.list")}>
                            <TabListRoutes />
                        </Tab>
                    </Tabs>
                </div>
            </div>
        </>
    );
};

export default ViewCalendar;
